import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { Col, Container, Row } from 'reactstrap';
import DataTable from '../../shared/components/DataTable';
import StudentSubjectFilterForm from './FilterForm';
import {
  reporteAlumnosFormData,
} from '../../redux/actions/studentsActions';
import {
  reporteAlumnosPorMateria,
  descargarReporteAlumnosPorMaterias,
} from '../../redux/actions/studentSubjectsActions';
import { createErrorMessage } from '../../helpers/notification';

class StudentsContainer extends PureComponent {
  static propTypes = {
    history: PropTypes.shape({}).isRequired,
  }

  constructor(props) {
    super(props);
    this.handleOnFilterChange = this.handleOnFilterChange.bind(this);
    this.descargarReporteAlumnosPorMaterias.bind(this);
    this.state = {
      page: 1,
      pageSize: 100,
      totalItemsCount: 0,
      loading: true,
      items: [],
      filters: { id: 0 },
    };
    this.columns = [
      { key: 'numeroDocumento', name: 'C.I. Nº', width: '120px' },
      { key: 'apellido', name: 'Apellido', width: '15%' },
      { key: 'nombre', name: 'Nombre', width: '15%' },
      { key: 'phoneNumber', name: 'Teléfono', width: '10%' },
      { key: 'email', name: 'Correo', width: '15%' },
      { key: 'nombreMateria', name: 'Materia' },
      {
        key: 'fechaIngreso',
        className: 'text-center',
        name: 'Año Ingreso',
        width: '130px',
        format: row => new Date(row.fechaIngreso).getFullYear(),
      },
      { key: 'nombreCarrera', name: 'Carrera' },
      {
        key: 'numeroSemestre',
        name: 'Semestre',
        width: '90px',
        format: row => `${row.numeroSemestre}º`,
      },
      {
        key: 'porcentajeAsistencia',
        name: '% Asistencia',
        type: 'number',
        width: '120px',

      },
      {
        key: 'porcentajePP',
        name: '% PP',
        type: 'number',
        width: '120px',
      },
    ];
  }

  componentDidMount() {
    const { page, pageSize } = this.state;
    this.fetchFormData(page, pageSize);
  }

  fetchFormData = () => {
    reporteAlumnosFormData({
      onSuccess: (formData) => {
        const { materias } = formData;
        const distinctMaterias = materias.filter((v, index, self) => self.map(x => x.label).indexOf(v.label) === index);
        this.setState({
          ...formData,
          todasLasMaterias: materias,
          materias: distinctMaterias,
        });
      },
      onError: () => {
        this.setState({ items: [], loading: false });
        createErrorMessage('Error al intentar cargar los datos del formulario');
      },
    });
  }

  updateStudentsTable = (page, pageSize, filters) => {
    this.setState({
      loading: true,
      page,
      pageSize,
      filters: filters || {},
    });
    reporteAlumnosPorMateria({
      pageInfo: {
        page,
        pageSize,
        filters: filters || {},
      },
      onSuccess: (pageInfo) => {
        this.setState({
          loading: false,
          items: pageInfo.items,
          totalItemsCount: pageInfo.totalItemsCount,
        });
      },
      onError: () => {
        this.setState({ items: [], loading: false });
        createErrorMessage('Error al intentar cargar la lista de alumnos');
      },
    });
  }

  handleOnFilterChange = (objectKey, idKey, value) => {
    if (objectKey === 'periodo' || objectKey === 'carrera') {
      const { carreraId, periodoId, todasLasMaterias } = this.state;

      const newCarreraId = objectKey === 'carrera' ? value.value : carreraId;
      const newPeriodoId = objectKey === 'periodo' ? value.value : periodoId;

      let materias = todasLasMaterias.filter(m => (!newCarreraId || m.carreraId === newCarreraId)
        && (!newPeriodoId || m.periodoId === newPeriodoId));

      // Filter distinct and use MateriaId
      materias = materias.filter((v, index, self) => self.map(x => x.label).indexOf(v.label) === index)
        .map(x => ({ label: x.label, value: x.materiaId }));
      this.setState({
        [idKey]: value.value,
        [objectKey]: value,
        materias,
      });
    } else {
      this.setState({
        [idKey]: value.value,
        [objectKey]: value,
      });
    }

    const { filters } = this.state;
    filters[idKey] = value.value;

    this.setState({
      filters,
    });
  }

  handleOnFilter = () => {
    const { page, pageSize, filters } = this.state;
    this.updateStudentsTable(page, pageSize, filters);
  }

  onChangePage = (page) => {
    if (page) {
      const { pageSize, filters } = this.state;
      this.updateStudentsTable(page, pageSize, filters);
    }
  };

  onDataTableSubmit = (values) => {
    if (values) {
      const { pageSize } = this.state;
      this.updateStudentsTable(1, pageSize, values);
    }
  };

  onDataTableClearFilters = () => {
    const { pageSize } = this.state;
    this.updateStudentsTable(1, pageSize, {});
  };

  getGridActions = (key) => {
    const actions = {
      actions: this.actions,
    };
    return actions[key];
  }

  descargarReporteAlumnosPorMaterias = () => {
    const { filters } = this.state;
    descargarReporteAlumnosPorMaterias({
      filters: filters || {},
      onError: () => {
        createErrorMessage('Error al intentar descargar la lista de alumnos');
      },
    });
  }

  render() {
    const {
      loading,
      items,
      page,
      pageSize,
      totalItemsCount,
      filters,
    } = this.state;

    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">Reporte de Asistencias y Pruebas Parciales</h3>
          </Col>
        </Row>
        <Row>
          <StudentSubjectFilterForm
            {...this.state}
            onFilterChanges={this.handleOnFilterChange}
            onFilter={this.handleOnFilter}
          />
        </Row>
        <Row>
          <Col md={12} className="text-right">
            {items.length && (
              <button
                className="btn btn-link"
                type="button"
                onClick={this.descargarReporteAlumnosPorMaterias}
              >
                <span className="fa fa-cloud-download">&nbsp;</span>
                Descargar lista
              </button>
            )}
          </Col>
        </Row>
        <Row>
          {loading ? <Col md={12}><h3 className="page-subhead subhead">Esperando su b&uacute;squeda...</h3></Col>
            : (
              <DataTable
                title="Asistencias y pruebas parciales"
                columns={this.columns}
                items={items}
                onChangePage={this.onChangePage}
                page={page}
                pageSize={pageSize}
                totalItemsCount={totalItemsCount}
                onSubmit={this.onDataTableSubmit}
                onClearFilters={this.onDataTableClearFilters}
                initialValues={filters}
                enableReinitialize
              />
            )
          }
        </Row>
      </Container>
    );
  }
}

export default withRouter(StudentsContainer);
